export default "__VITE_ASSET__6b0c2863__"